/* avatar is decorative — nothing to do at runtime */
export function initAvatar(): void {
  /* reserved for future progressive enhancement */
}
